<template>
  <div class="md-layout main-page">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card">
        <md-card-content class="mobile-content">
          <md-list class="md-dense menu-list">

            <md-list-item to="/payments">
              <div>
                <svgIcon class="menu-icon" icon="payment" />
                <span class="menu-label">Оплата</span>
              </div>

              <div>
                <span
                  class="status-label"
                  :style="{color: `#${paymentsStatusColor}`}"
                >
                  {{ paymentsStatusLabel }}
                </span>
                <md-icon>chevron_right</md-icon>
              </div>
            </md-list-item>

            <md-divider class="md-inset"></md-divider>

            <md-list-item to="/counters">
              <div>
                <svgIcon class="menu-icon" icon="counters" />
                <span class="menu-label">Счетчики</span>
              </div>

              <div>
                <span
                  class="status-label"
                  :style="{color: `#${countersStatusColor}`}"
                >
                  {{ countersStatusLabel }}
                </span>
                <md-icon>chevron_right</md-icon>
              </div>
            </md-list-item>

            <md-divider class="md-inset"></md-divider>

            <md-list-item to="/appeals">
              <div>
                <svgIcon class="menu-icon" icon="appeals" />
                <span class="menu-label">Заявки</span>
              </div>

              <div>
                <span
                  class="status-label"
                  :style="{color: `#${appealsStatusColor}`}"
                >
                  {{ appealsStatusLabel }}
                </span>
                <md-icon>chevron_right</md-icon>
              </div>
            </md-list-item>

            <md-divider class="md-inset"></md-divider>

            <md-list-item to="/news">
              <div>
                <svgIcon class="menu-icon" icon="news" />
                <span class="menu-label">Новости</span>
              </div>

              <md-icon>chevron_right</md-icon>
            </md-list-item>

            <md-divider class="md-inset"></md-divider>

            <md-list-item to="/contacts">
              <div>
                <svgIcon class="menu-icon" icon="contacts" />
                <span class="menu-label">Контакты</span>
              </div>

              <md-icon>chevron_right</md-icon>
            </md-list-item>

            <md-divider class="md-inset"></md-divider>

            <md-list-item v-if="phones.length > 0" @click="phonesModal = true">
              <div>
                <svgIcon class="menu-icon" icon="dispatcher" />
                <span class="menu-label">Диспетчер</span>
              </div>

              <md-icon>chevron_right</md-icon>
            </md-list-item>
            <md-divider class="md-inset"></md-divider>
          </md-list>
        </md-card-content>
      </md-card>
      <modal v-if="phonesModal" @close="phonesModal = false">
        <div slot="header">
          <div class="text-align-center text-main-black">
            {{ phonesTitle }}
          </div>
        </div>
        <div v-if="phones.length > 0" slot="body" class="dis-phones">
          <div class="text-align-center">
            <div v-for="(number, i) in phones" :key="i">
              <a
                class="text-grey-1"
                :key="i"
                :href="`tel:${number}`">
                {{ number }}
              </a>
            </div>
          </div>
          <md-button
            class="md-button md-simple"
            @click="phonesModal = false"
          >
            Закрыть
          </md-button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from '@/components/Modal'
import svgIcon from '@/components/SVGIcon'

export default {
  name: "MainPage",
  components: {
    Modal,
    svgIcon
  },
  data() {
    return {
      phonesModal: false
    }
  },
  computed: {
    ...mapGetters([
      'getPersonalAccountInfo',
      'getManageOrganizationInfo'
    ]),

    paymentsStatusColor() {
      if (this.getPersonalAccountInfo) {
        const color = this.getPersonalAccountInfo.paymentsStatus.color;
        if (color === 'ff0000') {
          return 'ccc';
        }
        return '999';
      }
      return '999'
    },

    paymentsStatusLabel() {
      if (this.getPersonalAccountInfo) {
        return this.getPersonalAccountInfo.paymentsStatus.value;
      }
      return null;
    },

    countersStatusLabel() {
      if (this.getPersonalAccountInfo) {
        const val = this.getPersonalAccountInfo.countersStatus.value;
        return val && val !== 'показания' ? val : null;
      }
      return null;
    },

    countersStatusColor() {
      if (this.getPersonalAccountInfo) {
        const color = this.getPersonalAccountInfo.countersStatus.color;
        if (color === 'ff0000') {
          return 'ccc';
        }
        return '999';
      }
      return '999'
    },

    appealsStatusLabel() {
      if (this.getPersonalAccountInfo) {
        return this.getPersonalAccountInfo.appealsStatus.value;
      }
      return null;
    },

    appealsStatusColor() {
      if (this.getPersonalAccountInfo) {
        const color = this.getPersonalAccountInfo.appealsStatus.color;
        if (color === 'ff0000') {
          return 'ccc';
        }
        return '999';
      }
      return '999'
    },

    phonesTitle() {
      if (!this.getManageOrganizationInfo.services) {
        return '';
      }
      const { name, comment } = this.getManageOrganizationInfo.services.mainScreenPhone;
      return `${name}${comment ? ` (${comment})` : ''}`;
    },

    phones() {
      if (!this.getManageOrganizationInfo.services) {
        return [];
      }
      return this.getManageOrganizationInfo.services.mainScreenPhone.value.split(',').filter(e => e);
    },
  },
};
</script>

<style scoped lang="scss">
.main-page {
  .md-card {
    @media (max-width: 768px) {
      background-color: transparent;
      box-shadow: unset;
    }
  }
  .menu-list {
    margin-bottom: 20px;
    .status-label {
      vertical-align: middle;
    }
    .md-list-item .md-icon {
      color: var(--md-theme-main-bar-color) !important;
    }
    @media (max-width: 768px) {
      background-color: transparent;
    }
  }
}
.md-divider.md-inset {
  margin-left: 55px !important;
}
.menu-icon {
  color: var(--md-theme-main-bar-color);
  margin-right: 15px;
  vertical-align: middle;
}
.menu-label {
  font-size: 14px;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--md-theme-text-black-color);
}
</style>
